import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'

export const cashFlowMonthSchema = z.object({
  month: z.number().int().min(1).max(12),
  openingBalance: z.number(),
  income: z.number(),
  expense: z.number(),
  closingBalance: z.number(),
})

export type CashFlowMonthDto = z.infer<typeof cashFlowMonthSchema>

export const cashFlowUnlinkedSettlementAccountSchema = z.object({
  id: z.string().guid(),
  name: z.string(),
})

export type CashFlowUnlinkedSettlementAccountDto = z.infer<
  typeof cashFlowUnlinkedSettlementAccountSchema
>

export const cashFlowSummaryResponseSchema = z.object({
  account: z.object({
    id: z.string().guid(),
    name: z.string(),
    currency: z.nativeEnum(Currency),
  }),
  year: z.number().int(),
  openingBalance: z.number(),
  months: z.array(cashFlowMonthSchema).length(12),
  closingBalance: z.number(),
  // unselected accounts that hold settlement debts for rounds touching the
  // user's selected-account expenses. when non-empty in showRecalculated mode,
  // settled-shared expenses on selected accounts whose round posts here keep
  // their full amount (the share view doesn't apply because the (1−share)
  // refund lives on these accounts). the frontend surfaces this via a banner.
  unlinkedSettlementAccounts: z.array(cashFlowUnlinkedSettlementAccountSchema),
})

export type CashFlowSummaryResponseDto = z.infer<typeof cashFlowSummaryResponseSchema>
